import { Icon, Notice, Shadow, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { BasketAdvisorOrderEntity } from '@genial/services';
import { Utils, useBreakpointValue } from '@genial/utils';
import { Box, FlatList, Text } from 'native-base';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { sessionState } from '../../../../../../store/session/atom';
import { flatListProps, noticeBatchTicketSentSection } from '../../../../utils';
import { ItemSeparator } from '../../../ItemSeparator';
import { Item } from '../Item';

interface ContentProps {
  data: BasketAdvisorOrderEntity;
}

interface WrapperProps {
  children: React.ReactNode;
}

const DesktopWrapper: React.FC<WrapperProps> = ({ children }) => (
  <Shadow level={1} borderTopRadius={BoxRadius.sm}>
    {children}
  </Shadow>
);

const MobileWrapper: React.FC<WrapperProps> = ({ children }) => (
  <Box borderTopRadius={BoxRadius.sm}>{children}</Box>
);

export const Content: React.FC<ContentProps> = ({ data }) => {
  const Wrapper = useBreakpointValue({
    base: MobileWrapper,
    sm: DesktopWrapper,
  });

  const basketOrders = data.basketCustomerOrders?.map((item) => item.basketCustomerOrder) || [];
  const { userProfile } = useRecoilValue(sessionState);
  const isManager = !!(userProfile?.isGestor && userProfile?.idTipoParceiro !== 4);

  return (
    <Wrapper>
      <VStack space={Spacing['inline.xxxs']} p={{ sm: Spacing['inline.xxs'] }}>
        <Box
          p={Spacing['inline.nano']}
          borderRadius={BoxRadius.sm}
          bg={Utils.ColorToken.WithOpacity('neutral.lightest', 0.2)}>
          <HStack space={Spacing['inline.nano']}>
            <Icon testID="qa" name="Check" size="md" color={Color['feedback.success.default']} />
            <VStack space={Spacing['inline.quarck']} flex={1}>
              <Text
                fontSize={Typography['fontsize.lg']}
                variant="semibold"
                color={Color['neutral.black']}>
                Ordem #{data.basketOrderHash} enviada com sucesso.
              </Text>
              <Text
                fontSize={Typography['fontsize.lg']}
                variant="regular"
                color={Color['neutral.black']}>
                Você poderá acompanhar suas ordens clicando no botão{' '}
                <Text fontWeight="semibold">acompanhar.</Text>
              </Text>
            </VStack>
          </HStack>
        </Box>
        {!isManager && (
          <Notice
            testId="money-notice"
            backgroundColor={Utils.ColorToken.WithOpacity(
              'feedback.attention.lightest',
              'opacity.medium'
            )}
            type="warning"
            fontSize={Typography['fontsize.md']}
            textObjects={noticeBatchTicketSentSection}
          />
        )}
        <Shadow level={3}>
          <FlatList
            {...flatListProps}
            data={basketOrders}
            keyExtractor={(item) => item.basketAdvisorOrderId}
            maxH="590px"
            flex={1}
            ItemSeparatorComponent={ItemSeparator}
            renderItem={({ item }) => <Item item={item} basketData={data} />}
          />
        </Shadow>
      </VStack>
    </Wrapper>
  );
};
